import clsx from 'clsx'
import { POST_CLAIM_INVITE, postClaimInviteHref } from 'lib/community/model'
import { newTabProps, usePrefersNewTab } from 'lib/community/use-writer-handoff'
import { publicConfig } from 'config'
import styles from './PostClaimInvite.module.css'

interface PostClaimInviteProps {
  /** The author's thread when the review is live and its product page is known
   *  (`communityThreadHref`); null → the community home. */
  thread: string | null
  /** The host's analytics, where its page has a fitting event (the return card's
   *  `owner_return_click{community}`); the band and the reward screen send none. */
  onClick?: () => void
  className?: string
}

/**
 * The one line after a successful claim anywhere in the owner journey (owner funnel C13): the
 * band's accept or held result, the community writer's reward screen, the return card's
 * "Keep it yours". "Join the conversation in Community →" to the author's thread, else the
 * community home (`postClaimInviteHref`). Same tab on the server pass and phones, a new tab on
 * a desktop after mount — the accept result's convention. No points, no figure.
 */
const PostClaimInvite: React.VFC<PostClaimInviteProps> = ({ thread, onClick, className }) => {
  const newTab = usePrefersNewTab()
  return (
    <p className={clsx(styles.invite, className)}>
      <a
        href={postClaimInviteHref(thread, publicConfig('useTrailingSlash'))}
        className={styles.link}
        onClick={onClick}
        {...newTabProps(newTab)}
      >
        {POST_CLAIM_INVITE}
      </a>
    </p>
  )
}

export default PostClaimInvite
